// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n"; // Importa la configuración de i18next
import App from "./App";
import "./index.css";
import keycloak from "../keycloak"; // Asegúrate de que la ruta es correcta
import KeycloakContext from "../keycloakContext"; // Asegúrate de que la ruta es correcta

// Inicializa Keycloak y, tras la autenticación, renderiza la aplicación
keycloak
  .init({
    onLoad: "check-sso",
    pkceMethod: "S256",
    checkLoginIframe: false,
    enableLogging: true,
  })
  .then((authenticated) => {
    console.log("Keycloak authenticated:", authenticated);
    ReactDOM.createRoot(document.getElementById("root")).render(
      <React.StrictMode>
        <KeycloakContext.Provider value={keycloak}>
          <App />
        </KeycloakContext.Provider>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error("Error initializing Keycloak:", error);
    ReactDOM.createRoot(document.getElementById("root")).render(
      <React.StrictMode>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <h1>Error initializing application</h1>
          <p>{error.message}</p>
          <p>Please refresh the page or contact support.</p>
        </div>
      </React.StrictMode>
    );
  });
